// File: clientapp/src/components/ProtectedRoute.js

import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

export default function ProtectedRoute({ children }) {
    const { isAuthenticated, loadingAuth, user } = useContext(AuthContext);
    const location = useLocation();

    // Avoid flickering during load
    if (loadingAuth) {
        return <div>Loading...</div>;
    }

    // Let /changePassword route render even if auth hasn't finished
    const isOnChangePasswordPage = location.pathname === '/changePassword';

    if (!isAuthenticated && !isOnChangePasswordPage) {
        return <Navigate to="/login" replace />;
    }

    if (user?.mustChangePassword && !isOnChangePasswordPage) {
        return <Navigate to="/changePassword" replace />;
    }

    return children;
}

